import "../styles/Detailsnews.css";
import parse from "html-react-parser";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

const CampaignPage = () => {
  const navigate = new useNavigate()

  const [Campaign, setCampaign] = useState([]);
  const GetCampign = async () => {
    try {
      const getdata = await axios.get(
        `https://thekitu.com/api/admin/getCampaign`
      );
      if (getdata.status === 200) {
        setCampaign(getdata.data.news);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetCampign();
  }, [])
  return (
    <div>
      <div className="gallery">
        {" "}
        <h1 style={{ borderBottom: "3px solid white" }}>Campaign</h1>
        <Breadcrumb className="myBreadcrumb">
          <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
          <Breadcrumb.Item href="/studyandresearchcenter">
            Campaign
          </Breadcrumb.Item>

        </Breadcrumb>
      </div>
      <div className="container">
        <section>
          <div className="row">
            {Campaign?.map((item, i) => {
              return (
              
                <div className='col-md-4'>
                  <div className="event-card" style={{ position: "relative", width: "380px", height: "100%", overflow: "hidden" }}>
                    <img
                      src={`https://thekitu.com/Campaign/${item?.image}`}
                      alt=""
                      style={{
                        
                        width: "380px",
                        height: "285px",
                        objectFit: "cover",
                        top: 0,
                        left: 0,
                        zIndex: 0,
                      }}
                    />
                      <div className="">
                        <Link to={`/campaign/${item?._id}`} className="text-decoration-none text-dark"><h5 className="mt-2 lineclamp" style={{textAlign:"start"}}>{item?.title}</h5></Link>
                        <p
                          dangerouslySetInnerHTML={{
                            __html:
                              item?.description
                          }}
                          className="lineclamp"
                        style={{ textAlign: "start" }}
                        />
                      </div>
                  </div>
                </div>
              )
            })}
          </div>
        </section>
      </div>
    </div>
  )
}

export default CampaignPage